// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckboxStyles_container__S67DG","checkBoxText":"CheckboxStyles_checkBoxText__1PLik"};